export const commonStyles = (FOUNDATIONS, FONT) => ({
    wrapper: {
        border_radius: FOUNDATIONS.radius_1000,
        width: FOUNDATIONS.size_450,
        height: FOUNDATIONS.size_300,
        margin: 'auto',
        display: 'inline-flex',
        position: 'relative',
        align_items: 'center',
        padding_left: '0.0625rem',
        padding_right: '0.0625rem',
    },
    thumb: {
        background_color: '#ffffff',
        height: FOUNDATIONS.size_250,
        width: FOUNDATIONS.size_250,
        display: 'flex',
        position: 'absolute',
        border_radius: '100%',
        justify_content: 'center',
        align_items: 'center',
        transition: '0.4s',
    },
    icon: {
        height: FOUNDATIONS.size_250,
        width: FOUNDATIONS.size_250,
    },
});
//# sourceMappingURL=commonStyles.js.map